var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHealthFacilityHospitalPrivate = function SvgHealthFacilityHospitalPrivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002BFF",
    d: "M12.561 3.08H4.77C3.239 3.08 2 4.21 2 5.603v12.953c0 1.394 1.24 2.524 2.769 2.524h7.792c1.53 0 2.769-1.13 2.769-2.524V5.603c0-1.393-1.24-2.523-2.769-2.523"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.466 13.165v4.815h-1.83V7.134h1.83v4.478h4.552V7.134h1.822V17.98h-1.822v-4.815z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002BFF",
    d: "m20.486 21.08-1.121-2.642h-1.512v2.642h-1.098v-6.507h2.646c.723 0 1.268.166 1.634.5.366.33.549.785.549 1.367 0 .477-.111.86-.334 1.148a2.189 2.189 0 0 1-.863.666l1.237 2.826zm-1.332-3.51c.41 0 .733-.096.967-.288.234-.192.351-.46.351-.801 0-.333-.108-.591-.324-.774-.213-.186-.5-.28-.86-.28h-1.435v2.143z"
  })));
};
export default SvgHealthFacilityHospitalPrivate;